import { render, staticRenderFns } from "./AstrictMask.vue?vue&type=template&id=aa03f334&scoped=true&"
import script from "./AstrictMask.vue?vue&type=script&lang=js&"
export * from "./AstrictMask.vue?vue&type=script&lang=js&"
import style0 from "./AstrictMask.vue?vue&type=style&index=0&id=aa03f334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa03f334",
  null
  
)

export default component.exports